import React, { useEffect, useState, useContext, useRef } from 'react';
import ApplicationContext from './ApplicationContext';
import { findCurrentLang, readCookie } from './Utils'; 

const numberWithCommas = (input) => {
    if (input) {
        input = parseFloat(input);
        input = input.toFixed(2);
        input = input.toString();
        const parts = input.split('.');
        let value;
        let twoParts = false;
        if (parts.length === 2) {
        	twoParts = true;
        }
        value = parts[0]
    
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(value))
        	value = value.replace(pattern, "$1,$2");
        return `${value}${twoParts ? ('.' + parts[1]) : ""}`;
    }
};

const Quote = ({entry, exchangeInfoMap}) => {
    // JHP: Closed down the countdown timers for monetization temporarilty.
    const [Countdown, setCountdown] = useState(false);
    const [countdownUtils, setCountdownUtilsUtils] = useState({});

    useEffect(() => {
        if (Countdown) {
            import('./Countdown').then(module => {
                setCountdown(() => module.default); // Set the imported component
            });

            // Dynamically import the utility functions
            import('./CountdownUtils').then(countdownUtils => {
                setCountdownUtilsUtils({
                    getTimeZoneOffset: countdownUtils.getTimeZoneOffset,
                    formatDateTime: countdownUtils.formatDateTime,
                    getCountDownTime: countdownUtils.getCountDownTime,
                });
            });
        }
    }, [Countdown, countdownUtils, countdownUtils.enableCountdown]); // Re-run effect if `enableCountdown` changes

    const loaded = useRef(false);
    const [symbol, setSymbol] = useState(null);
    const [name, setName] = useState(null);
    const [value, setValue] = useState(null);
    const [valueChange, setValueChange] = useState(null);
    const [percentChange, setPercentChange] = useState(null);
    const [hideUpArrow, setHideUpArrow] = useState('');
    const [hideDownArrow, setHideDownArrow] = useState('');
    const [colorClass, setColorClass] = useState('');
	const data = useContext(ApplicationContext);

    useEffect(() => {
        if (entry.data.length === 5) {
            setName(entry.data[0]);
            setSymbol(entry.data[1]);
            setValue(entry.data[2]);
            setValueChange(entry.data[3]);
            setPercentChange(entry.data[4]);

            const sign = entry.data[3].slice(0,1);
            if (sign === '+') {
                setHideDownArrow('hidden');
                setHideUpArrow('');
                setColorClass('positive-growth');
            }
            else {
                setHideDownArrow('');
                setHideUpArrow('hidden');
                setColorClass('negative-growth');
            }
        }
    }, [entry.data]);

    // JHP: Closed down the countdown timers for monetization temporarilty.

    const [exchangeInfo, setExchangeInfo] = useState();
    const [jsTimeZone, setJsTimeZone] = useState();
    useEffect(() => {
        // console.log("DEBUG: Quote - exchangeInfoMap = ", JSON.stringify(exchangeInfoMap));
        // console.log("DEBUG: Quote - symbol = ", symbol);
        if (exchangeInfoMap && symbol) {
            const res = exchangeInfoMap[symbol];
            if (res) {
                setExchangeInfo(res['exchange-info']);
                setJsTimeZone(res['time-zone']);
            }
        }
    }, [exchangeInfoMap, symbol]);

    // JHP: Closed down the countdown timers for monetization temporarilty.

    const [countdownDate, setCountdownDate] = useState();
    const [countdownDateTag, setCountdownDateTag] = useState();
    useEffect(() => {
        if (Countdown && exchangeInfo) {
            // console.log('DEBUG: exchangeInfo = ', exchangeInfo);
            const tradingDays = exchangeInfo['tradingDays'];
            const tradingHours = exchangeInfo['tradingHours'];
            const bankHolidays = exchangeInfo['bankHolidays'];

            // console.log('DEBUG: jsTimeZone = ', jsTimeZone);
            // console.log('DEBUG:', tradingDays);
            // console.log('DEBUG:', tradingHours);
            // console.log('DEBUG:', bankHolidays);
            const tzOffset = countdownUtils.getTimeZoneOffset(jsTimeZone);

            let currentDate = new Date();
            let {newDate, openOrCloseTag} = countdownUtils.getCountDownTime(currentDate, jsTimeZone, bankHolidays, tradingDays, tradingHours);
            // console.log('DEBUG:', newDate);
            let {formattedDate:parsedDate, formattedTime:parsedTime} = countdownUtils.formatDateTime(newDate, jsTimeZone, true, true);
            setCountdownDate(`${parsedDate}T${parsedTime}:00.000${tzOffset}`);
            setCountdownDateTag(openOrCloseTag);
            // console.log('DEBUG:', `${parsedDate}T${parsedTime}:00.000${tzOffset}`);
            // console.log('DEBUG:', openOrCloseTag);
        }
    }, [Countdown, countdownUtils, jsTimeZone, exchangeInfo]);

    const [currentLangSelection, setCurrentLangSelection] = useState();

    useEffect(() => {
        // console.log(`DEBUG:  Quote - readCookie("googtrans") = ${readCookie("googtrans")}`);
        // console.log(`DEBUG:  Quote - findCurrentLang(readCookie("googtrans")) = ${findCurrentLang(readCookie("googtrans"))}`);
        setCurrentLangSelection(findCurrentLang(readCookie("googtrans")));

        if (loaded.current === false) {
			loaded.current = true;

            // const elem = document.getElementsByClassName(".goog-te-menu-value span:first")[0];
            // console.log(`DEBUG:  Quote - elem - ${JSON.stringify(elem)}`);

            document.getElementById("google_translate_element").addEventListener('change', (e) => {
                // console.log(`DEBUG:  Quote - new value = ${JSON.stringify(e.target.value)}`);
                setCurrentLangSelection(e.target.value);
            });
        }
    }, []);

    const needWiderQuoteCells = (lang, activeRegion) => {
        lang = lang || "en";

        // console.log(`DEBUG:  lang:  ${lang}`);
        // console.log(`DEBUG:  activeRegion:  ${activeRegion}`);
    
        if (!activeRegion) {
            return false;
        }
    
        // console.log(`DEBUG:  data.intl - ${JSON.stringify(data.intl)}`);
    
        const foundLang = data.intl?.find(e => e.lang === lang);

        let foundRegion;
        if (foundLang) {
            foundRegion = foundLang.regions?.find(e => activeRegion === e);
        }
    
        // console.log(`DEBUG:  foundLang:  ${JSON.stringify(foundLang)}`);
        // console.log(`DEBUG:  foundRegion:  ${JSON.stringify(foundRegion)}`);
        let res = (foundLang !== undefined && foundRegion !== undefined);
    
        // console.log(`DEBUG:  res - ${JSON.stringify(res)}`);
        return res;
    };

    // Color codes:
    // positive-growth for green
    // negative-growth for red
	return (
        <div className='quote-item'>
            {/* {(() => {
                console.log(`DEBUG:  Quote - currentLangSelection:  ${currentLangSelection}`);
            })()} */}
            <a className="quote-anchor" href={"https://finance.yahoo.com/quote/" + symbol} target="_blank" rel="noreferrer" data-param={symbol} 
            style={needWiderQuoteCells(!currentLangSelection ? "en" : currentLangSelection, data?.activeRegion) ? {width:190} : {}}>
                <div className="image-padding">
                    <span className="image-container">
                        <svg id="up-arrow" width="16" height="16" viewBox="0 0 24 24" focusable="false" className={`current-color positive-growth ${hideUpArrow}`}>
                            <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
                        </svg>
                        <svg id="down-arrow" width="16" height="16" viewBox="0 0 24 24" focusable="false" className={`current-color negative-growth ${hideDownArrow}`}>
                            <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
                        </svg>
                    </span>
                </div>
                <div className="name-value-label">
                    <div>{name}</div>
                    <div>{numberWithCommas(value)}</div>
                </div>
                <div className="changes-label-container">
                    <div className={`changes-label ${colorClass}`}>
                        <div>{`${valueChange>0 ? '+':''}${parseFloat(valueChange).toFixed(2)}`}</div>
                        <div>{`${percentChange>0 ? '+':''}${parseFloat(percentChange).toFixed(2)}%`}</div>
                    </div>
                </div>
            </a>
            {/* JHP: Closed down the countdown timers for monetization temporarilty. */}
            {Countdown ? countdownDate && <Countdown date={countdownDate} tag={countdownDateTag} /> : <></>}
		</div>
	);
};

export default Quote;
